import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import React from 'react';
import * as constants from '../../store/Constants';
import { Recipe } from '../../store/Recipe';
import { onClickUrl } from '../../utils/OpenLink';
import CardMedia from '@mui/material/CardMedia';
import { isValidHttpUrl } from '../../utils/ServerCommunications';

const columnSx = { display: "inline" }
const detailSx = { display: "inline", fontWeight: 600 }
const emptyCellText = "..."

function timeFormat(time: string): string {
  const timeFloat = parseFloat(time)
  if (timeFloat) {
    if (timeFloat < 1.0) {
      return (timeFloat * 60.0).toFixed(0).toString() + " mins"
    } else {
      const hours = Math.floor(timeFloat)
      const minutes = (timeFloat - hours) * 60.0
      var hourString = ""
      if (hours === 1) {
        hourString = hours.toFixed(0).toString() + " hr "
      } else {
        hourString = hours.toFixed(0).toString() + " hrs "
      }
      if (minutes === 0) {
        return hourString
      }
      return hourString + Math.round(minutes).toFixed(0).toString() + " mins"
    }
  } else {
    return emptyCellText
  }
}

interface CardDetailsInterface {
  recipe: Recipe
  column: string
}

const CardDetails = (props: CardDetailsInterface) => {
  var value = props.recipe[props.column]
  if (props.column === constants.Time) {
    value = timeFormat(value)
  }

  if (props.column === constants.Cuisine) {
    value = value?.charAt(0).toUpperCase() + value?.slice(1);
  }

  if (!value) {
    value = emptyCellText
  }

  return (
    <div>
      <Typography sx={columnSx} variant="body2">
        {props.column}:&nbsp;
      </Typography>
      <Typography sx={detailSx} variant="body2">
        {value}
      </Typography>
    </div>
  )
}

interface RecipeListItemDetails {
  recipe: Recipe,
  index: number,
  style?: React.CSSProperties,
}

const RecipeListItem = (props: RecipeListItemDetails) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const linkString = props.recipe[constants.Link]
  var linkHostname = ""
  if (isValidHttpUrl(linkString)) {
    const linkUrl = new URL(linkString)
    linkHostname = linkUrl.hostname
  }

  var renderImage = false
  var imageLink = ""
  if (props.recipe[constants.Image] !== undefined && props.recipe[constants.Image] !== null) {
    renderImage = true
    imageLink = props.recipe[constants.Image]
  }

  return (
    <div style={props.style}>
      <ListItem
        key={props.index}
        secondaryAction={
          <IconButton aria-label="comments" onClick={onClickUrl(props.recipe[constants.Link])} disabled={linkHostname === ""}>
            <OpenInNewIcon />
          </IconButton>
        }
        disablePadding
        sx={{ borderTop: 1, borderColor: '#e3e3e3' }}
      >
        <ListItemButton onClick={handleClick} dense={true} alignItems={'center'}>
          <ListItemText
            primary={props.recipe[constants.Name]}
            secondary={timeFormat(props.recipe[constants.Time])}
            primaryTypographyProps={{
              variant: 'subtitle2',
              style: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }
            }}
          />
        </ListItemButton>
      </ListItem>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Card sx={{ minWidth: 275, maxWidth: 345 }}>
          {renderImage &&
            <CardMedia
              component="img"
              height="194"
              image={imageLink}
              alt={props.recipe[constants.Name]}
            />
          }
          <CardContent>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
              {props.recipe[constants.Name]}
            </Typography>
            <CardDetails
              recipe={props.recipe}
              column={constants.EntryDate}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Category}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Cuisine}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Form}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Time}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Method}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Vegetarian}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Ingredients}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Notes}
            />
            <CardDetails
              recipe={props.recipe}
              column={constants.Lists}
            />
          </CardContent>
          {(linkHostname !== "") &&
            <CardActions>
              <Button onClick={onClickUrl(props.recipe[constants.Link])} size="small">Open Recipe On {linkHostname}</Button>
            </CardActions>
          }
        </Card>
      </Popover>
    </div>
  )
}

export default RecipeListItem


